import React, { useEffect, useState } from 'react';
import { Spin, Select, Row, Col, Card, Statistic, Button } from 'antd';
import { ProPageHeader as PageHeader } from '@ant-design/pro-layout';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { getSeasonDetails, getRound } from '../../../store/slices/adminSlice';
import { useParams } from 'react-router-dom';

const { Option } = Select;

// TypeScript interfaces
interface SportData {
  _id: string;
  sportname: string;
}

interface SeasonDetails {
  _id: string;
  seasonname: string;
  sport: SportData[];
  startDate?: string;
  endDate?: string;
}

interface RoundData {
  _id: string;
  roundname: string;
  roundno?: number;
}

interface RouteParams {
  seasonId: string;
}

const SeasonDetail: React.FC = () => {
  const dispatch = useAppDispatch();
  const { seasonId } = useParams<RouteParams>();

  // Redux state
  const seasonDetails = useAppSelector((state) => state.admin.seasonDetails) as SeasonDetails | any;
  const roundData = useAppSelector((state) => state.admin.roundData) as RoundData[];

  // Local state
  const [loading, setLoading] = useState<boolean>(true);

  // Load data on mount
  useEffect(() => {
    const obj = {
      seasonId: seasonId,
    };
    dispatch(getSeasonDetails(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seasonId]);

  // Update loading state when data changes
  useEffect(() => {
    if (seasonDetails) {
      setLoading(false);
    }
  }, [seasonDetails, roundData]);

  const handleMenuClick2 = (value: string) => {
    const obj = {
      sportId: value,
      page: 0,
    };
    dispatch(getRound(obj));
  };

  const season = seasonDetails ? seasonDetails : '';

  return (
    <>
      <div className="overflowBox">
        <PageHeader prefixedClassName="ant-page-header" title="SEASON PROFILE " subTitle="" />
        <Spin spinning={loading} delay={500}>
          <div className="box box-default mb-4">
            <Row>
              <Col style={{ height: '10vh' }} span={24}>
                <Card style={{ border: 'none' }} className="mb-4">
                  <Statistic
                    title="Season Name :-"
                    value={season.seasonname}
                    precision={0}
                  />
                </Card>
              </Col>
              <Col style={{ height: '12vh' }} span={24}>
                <Card style={{ border: 'none' }} className="mb-4">
                  <div className="ant-statistic">
                    <div className="ant-statistic-title">Season Sport List :-</div>
                    <div className="ant-statistic-content">
                      <Select
                        placeholder="Season"
                        style={{ width: 300 }}
                        onChange={handleMenuClick2}
                      >
                        {season === ''
                          ? null
                          : season.sport?.map((x: SportData, index: number) => {
                              return (
                                <Option value={x._id} key={index}>
                                  {x.sportname}
                                </Option>
                              );
                            })}
                      </Select>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col style={{ height: '12vh' }} span={24}>
                <Card style={{ border: 'none' }} className="mb-4">
                  <div className="ant-statistic">
                    <div className="ant-statistic-title">Sport Round List :-</div>
                    <div className="ant-statistic-content">
                      <Select placeholder="Season" style={{ width: 300 }}>
                        {roundData.length === 0
                          ? null
                          : roundData.map((x, index) => {
                              return (
                                <Option value={x._id} key={index}>
                                  {x.roundname}
                                </Option>
                              );
                            })}
                      </Select>
                      <Button style={{ marginLeft: '20px' }} type="primary">
                        Add Round
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </Spin>
      </div>
    </>
  );
};

export default SeasonDetail;
